
angular.module('bmsApp.crm.customer').controller('CustomerImportCtrl', [
	'$state',
	'$scope',
	'$timeout',
	'$log',
	'notify',
	'FileSvc',
	'CustomerGroupSvc',
	'CustomerSvc', function (
		$state,
		$scope,
		$timeout,
		$log,
		notify,
		FileSvc,
		CustomerGroupSvc,
		CustomerSvc) {

		$scope.customers = {
			csv: null,
			customer_groups: []
		};

		CustomerGroupSvc.options()
			.then(function (response) {
				$timeout(function () {
					$scope.$apply(function () {
						$scope.customerGroupOptions = response.data.options;
					});
				}, 0);
			});

		$scope.enableSubmit = false;
		$scope.processing = false;

		$scope.dropzone = {
			config: {
				url: '/api/file/upload',
				parallelUploads: 3,
				maxFileSize: 30,
				//maxFiles: 1,
				addRemoveLinks: true,
				acceptedFiles: '.csv',
				eventHandlers: {
					success: function (file, response) {
						$scope.customers.csv = response.filepath;
						file.serverFilepath = response.filepath;
						$timeout(function () {
							$scope.$apply();
						}, 0);
					},
					drop: function (event) {
						$timeout(function () {
							$scope.$apply(function () {
								$scope.enableSubmit = false;
								//$scope.processing = true;
							});
						}, 0);
					},
					queuecomplete: function () {
						console.info(this.files);
						$scope.enableSubmit = this.files.length ? true : false;
						$timeout(function () {
							$scope.$apply(function () {
								//$scope.processing = false;
							});
						}, 0);
					},
					addedfile: function () {
						// Remove old csv if new one dragged in
						if (this.files[1] != null) {
							this.removeFile(this.files[0]);
						}
					},
					removedfile: function (file) {
						var self = this;
						FileSvc.delete(file.serverFilepath)
							.then(function (response) {
								$scope.enableSubmit = self.files.length ? true : false;
								$log.log('Dropzone file removed');
							}, function (error) {
								$log.error('Failed to remove dropzone file: ' + error);
							});
					}
				}
			}
		};

		$scope.submit = function () {
			if (angular.isString($scope.customers.csv) === false) {
				$scope.errors = [
					'You must upload a CSV'
				];
				return;
			}

			$timeout(function () {
				$scope.$apply(function () {
					$scope.errors = false;
				});
			}, 0);
			$scope.processing = true;
			CustomerSvc.import($scope.customers)
				.then(function (response) {
					$scope.processing = false;
					notify({
						message: 'Customers imported successfully'
					});
					$state.go('main.crm.customer.index');
				}, function (errors) {
					$scope.errors = errors;
					$scope.processing = false;
				});
		};

		$scope.formvalidatorconfig = {
			submitHandler: function () {
				$scope.submit();
			},
			errorPlacement: function (error) {
				error.appendTo('#customer-import-errors');
			},
			errorContainer: '#customer-import-errors'
		};


	}]);
